//App Component

function App() {
  return (
    <div className="App">
      <h4>Hello Everyone</h4>
      <p>ReactJS 강의를 들으면서 개발했던 예제들을 모아둔 블로그입니다.</p>
      <div className="GitRepositoryURL">
        <a href="https://github.com/Rayched/React_Study">'React_Study' / Project Git Repository</a> 
      </div>
    </div>
  );
}

export default App;
